import { useEffect, type ReactNode } from "react";
import { useUIStore } from "@/stores/ui.store";

// ═══════════════════════════════════════════════════════════
// ThemeProvider — shadcn/ui dark/light mode (TPP §5.1)
// ═══════════════════════════════════════════════════════════

interface ThemeProviderProps {
  children: ReactNode;
}

export function ThemeProvider({ children }: ThemeProviderProps) {
  const theme = useUIStore((s) => s.theme);

  useEffect(() => {
    const root = window.document.documentElement;
    root.classList.remove("light", "dark");

    if (theme === "system") {
      const systemTheme = window.matchMedia("(prefers-color-scheme: dark)").matches
        ? "dark"
        : "light";
      root.classList.add(systemTheme);
    } else {
      root.classList.add(theme);
    }
  }, [theme]);

  return <>{children}</>;
}
